import { render, staticRenderFns } from "./vselect.vue?vue&type=template&id=c68b01fa&scoped=true"
import script from "./vselect.vue?vue&type=script&lang=js"
export * from "./vselect.vue?vue&type=script&lang=js"
import style0 from "./vselect.vue?vue&type=style&index=0&id=c68b01fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68b01fa",
  null
  
)

export default component.exports